import styled from "styled-components";

import { IStyledAttributes } from "@ryde/shared";

export const ProductionActionButtonStyled = styled.div.attrs<IStyledAttributes>(
  {
    "data-e2e": "production-action-button",
  },
)`
  button {
    width: 128px;
  }
`;
